import { render } from "./FeatureEditor.vue?vue&type=template&id=b8decfbe&scoped=true"
import script from "./FeatureEditor.vue?vue&type=script&lang=js"
export * from "./FeatureEditor.vue?vue&type=script&lang=js"

import "./FeatureEditor.vue?vue&type=style&index=0&id=b8decfbe&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8decfbe"]])

export default __exports__